import React, { useEffect, useState, useRef } from 'react';
import { Input, Select, message, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import SessionCard from '../../components/SessionCard/SessionCard';
import { FaFilter } from 'react-icons/fa';
import { IoClose } from 'react-icons/io5';
import Pagination from '../../components/Pagination/Pagination';
import { publicAxiosInstance } from '../../services/createAxiosInstance';
import { URLs } from '../../constants/apiEndpoints';
import './FilterPage.css';
import ErrorBoundary from '../../utils/Errorboundary';
import { Button } from '@nextui-org/react';
import { GrPowerReset } from 'react-icons/gr';

const { Search } = Input;
const { Option } = Select;

function FilterPage() {
  const [togglebtn, setTogglebtn] = useState(false);
  const filterRef = useRef(null);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [searchText, setSearchText] = useState('');
  const [eventStatus, setEventStatus] = useState('upcoming');
  const [medium, setMedium] = useState('');

  const { loading, data } = useSelector((state) => state.session);

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const handleEventStatus = (value) => {
    setEventStatus(value);
  };
  const handelMeduim = (value) => {
    setMedium(value);
  };

  const fetchData = async () => {
    try {
      const queryParams = new URLSearchParams({
        page: currentPage,
        limit: '9',
        sortBy: 'CreatedAt',
        sortOrder: 'asc',
        search: searchText,
        status: 'active',
        event_status: eventStatus,
        medium: medium,
      }).toString();

      const res = await publicAxiosInstance.get(
        `${URLs.FETCH_ALL_SESSION_URL}?${queryParams}`
      );
      setFilteredData(res?.data?.events || []);
      setTotalPages(res?.data?.pages || 1);
    } catch (error) {
      message.error('Failed to fetch session data');
      console.error('Error fetching sessions:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, searchText, eventStatus, medium]);

  // Handle reset filters
  const handleReset = () => {
    setSearchText('');
    setEventStatus('upcoming');
    setMedium('');
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const togglebtnFun = () => {
    setTogglebtn(!togglebtn);
  };

  const toggleFilterbtnFun = () => {
    setTogglebtn(false);
  };

  return (
    <>
      <div
        onClick={toggleFilterbtnFun}
        className="inline-grid grid-cols-2 lg:hidden ml-2 mt-5 mb-5 bg-gray-800 hover:bg-gray-700 rounded-lg p-1 cursor-pointer"
      >
        <FaFilter className="fill-gray-400 w-[17px] mt-2 ml-2 h-[17px] mb-2" />
        <h3 className="text-gray-400 text-h6 font-poppins font-bold ml-[-20px] mt-1 pr-1">
          Add filter
        </h3>
      </div>

      <>
        <div
          ref={filterRef}
          className={`${togglebtn ? 'hidden' : 'block'} grid  xl:grid-cols-4 lg:grid-cols-3 gap-5 order-b bg-neutral-800  ml-[-250px] lg:ml-0 w-full   sm:px-6 px-6 font-popins min-h-[70px] relative z-0`}
          style={{
            position: 'fixed',
            width: 'auto',
            zIndex: 40,
            top: 70,
            left: 250,
            right: 0,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
            font: 'poppins',
          }}
        >
          <div className="lg:hidden block">
            <IoClose
              onClick={togglebtnFun}
              className="flex justify-end mt-4 w-[25px] h-[25px] md:w-[35px] md:h-[35px] lg:hidden cursor-pointer text-white"
            />
          </div>

          <Search
            placeholder="Search by name or email"
            onSearch={handleSearch}
            onChange={(e) => handleSearch(e.target.value)}
            value={searchText}
            className="mt-5 custom-search-input"
            style={{ fontFamily: 'Poppins' }}
          />

          <div className="">
            <h4 className="text-gray-300 tracking-wider font-poppins text-paragraph-font-size font-medium">
              Event Status:
            </h4>
            <Select
              value={eventStatus}
              onChange={handleEventStatus}
              style={{ width: 200 }}
            >
              <Option value="">All</Option>
              <Option value="upcoming">Upcoming</Option>
              <Option value="complete">Complete</Option>
            </Select>
          </div>

          <div className="">
            <h4 className="text-gray-300 tracking-wider font-poppins text-paragraph-font-size font-medium">
              Language:
            </h4>

            <Select
              value={medium}
              onChange={handelMeduim}
              style={{ width: 200 }}
            >
              <Option value="">All</Option>
              <Option value="english">English</Option>
              <Option value="sinhala">Sinhala</Option>
            </Select>
          </div>

          <div className="flex justify-end items-center mb-2 sm:mb-0">
            <Button
              onClick={handleReset}
              startContent={<GrPowerReset fill="black" size={20} />}
              className="bg-gray-300  text-black cursor-pointer mt-3 md:mt-0 text-xs md:text-sm"
              size="sm"
            >
              Reset
            </Button>
          </div>
        </div>
      </>

      <div className="w-full ">
        {filteredData?.length === 0 && (
          <h1 className="flex justify-center text-white text-xs md:text-sm font-normal md:mt-[250px]">
            No Sessions Found
          </h1>
        )}

        {loading ? (
          <div className="flex justify-center items-center">
            <Spin />
          </div>
        ) : (
          <div className="grid xl:grid-cols-3 lg:grid-cols-1 md:grid-cols-1 gap-6 lg:mt-[130px]">
            {filteredData?.map((item) => (
              <ErrorBoundary>
                <SessionCard
                  key={item?.eventId}
                  id={item?.eventId}
                  eventName={item?.event_name}
                  presenter={item?.presenter}
                  date={item?.date}
                  startTime={item?.startTime}
                  endTime={item?.endTime}
                  description={item?.description}
                  category={item?.category}
                  imageSrc={item.coverImage[0]?.url}
                  isfilter={true}
                  isCollection={item?.isCollection}
                  eventCollectionId={item?.eventCollectionId}
                />
              </ErrorBoundary>
            ))}
          </div>
        )}
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </>
  );
}

export default FilterPage;
